import React, { useEffect, useRef } from 'react';

const MouseTrail = () => {
  const dotRef = useRef(null);
  const targetPosition = useRef({ x: 0, y: 0 });
  const currentPosition = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      targetPosition.current = { x: e.clientX, y: e.clientY };
    };

    const animate = () => {
      if (dotRef.current) {
        // Lerp towards target position (lower factor = more loose)
        currentPosition.current.x += (targetPosition.current.x - currentPosition.current.x) * 0.05;
        currentPosition.current.y += (targetPosition.current.y - currentPosition.current.y) * 0.05;
        
        dotRef.current.style.left = currentPosition.current.x - 6 + 'px';
        dotRef.current.style.top = currentPosition.current.y - 6 + 'px';
      }
      requestAnimationFrame(animate);
    };

    document.addEventListener('mousemove', handleMouseMove);
    animate();

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div
      ref={dotRef}
      className="fixed pointer-events-none z-50 w-3 h-3 bg-white rounded-full shadow-lg"
    />
  );
};

export default MouseTrail;
